// 本コンポーネントはwww_v2の領収書ページをbusiness向けに直したものです。

import React from 'react'

import styled from 'styled-components'

import { ReceiptHeader } from './components/ReceiptHeader'
import { ReceiptMainContent } from './components/ReceiptMainContent'

export const BillingReceipt = ({ receipt }) => {
  const { transactionDate, ...mainContentProps } = receipt

  return (
    <StyledBillingReceipt>
      <ReceiptHeader transactionDate={transactionDate} />
      <ReceiptMainContent {...mainContentProps} />
    </StyledBillingReceipt>
  )
}

const StyledBillingReceipt = styled.div`
  box-sizing: content-box;
  width: 820px;
  margin: 0 auto;
  padding: 12px 16px;
  line-height: 1.35;
`
